export const UserStrings = {
  en: {
    enterFirstName: 'Please input your firstName!',
    ldapusers: 'LDAP Users',
    enterLastName: 'Please input your lastName!',
    firstName: 'First Name',
    lastName: 'Last Name',
    enterEmail: 'Please input your email!',
    submit: 'Submit',
    email: 'Email',
    newPassword: 'New Password',
    oldPassword: 'Old Password',
    newPasswordChangeSuccessfully: 'Password changed successfully',
    enterPhoneNumber: 'Please input your email!',
    phoneNumber: 'Phone Number',
    phoneNum: 'PhoneNumber',
    changePassword: 'Change Password',
    password: 'Password',
    userUpdateSuccess: ' User Updated Successfully',
    editUser: 'Edit User',
    username: 'Username',
    fileUploadMaxLimitErr: 'Maximum allowed size 10MB',
    fileUploadSuccess: 'File uploaded successfully',
    name: 'Full Name',
    sessionExpired: 'Session Expired',
    logoutImmediately: 'Logout Immediately',
    sessionHasExpiredMessage:
      'Your Session Has expired, you will be redirected to login after after 10 seconds',
    accountEnabled: 'Account Enabled',
    changeLdapPassword: 'Change LDAP Password',
    passwordCriteria:
      'Note: Password must have at least 12 characters including 1 upper case, 1 lower case, 1 digit and 1 symbol from @#$%^&+=.',
    search: 'Search',
    clear: 'Clear',
    addUser: 'Add User',
    cancel: 'Cancel',
    passwordUpdateSuccess: 'New Password updated successfully.',
    userAddedSuccessfully: 'New user was added successfully.'
  },
  es: {
    enterFirstName: '¡Por favor ingrese su nombre!',
    enterLastName: '¡Por favor ingrese su apellido!',
    firstName: 'Primer nombre',
    lastName: 'Apellido',
    enterEmail: '¡Por favor ingrese su correo electrónico!',
    submit: 'Entregar',
    email: 'Correo electrónico',
    newPassword: 'Nueva contraseña',
    oldPassword: 'Contraseña anterior',
    newPasswordChangeSuccessfully: 'Contraseña cambiada con éxito',
    enterPhoneNumber: '¡Por favor ingrese su correo electrónico!',
    phoneNumber: 'Número de teléfono',
    phoneNum: 'Número de teléfono',
    changePassword: 'Cambia la contraseña',
    password: 'Contraseña',
    fileUploadMaxLimitErr: 'Tamaño máximo permitido 10 MB',
    fileUploadSuccess: 'El archivo ha subido correctamente',
    name: 'Nombre completo',
    sessionExpired: 'Sesión expirada',
    logoutImmediately: 'Cerrar sesión inmediatamente',
    sessionHasExpiredMessage:
      'Su sesión ha expirado, será redirigido para iniciar sesión después de 10 segundos',
    userUpdateSuccess: 'Usuario actualizada con éxito',
    editUser: 'editar usuario',
    username: 'Nombre de usuario'
  }
  /*
   * We can add multiple languages like this
   * fr: {
   *  enterEmail: 'Veuillez saisir votre e-mail !',
   *  email: 'e-mail'
   * } */
}
